import classnames from 'classnames';
import truncate from 'html-truncate';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { withLocalize } from 'react-localize-redux';
import { Link } from 'react-router-dom';

import "./news.css";

const PEREX_TEXT_LIMIT = 700;

class NewsContent extends React.Component {
    render() {
        const { text, isPerex, newsId } = this.props;

        return (
            <div className={classnames('bb-news-widget-content', { 'bb-news-widget-content-perex': isPerex })}>
                <div>{ReactHtmlParser(isPerex ? truncate(text, PEREX_TEXT_LIMIT, { keepImageTag: false }) : text)}</div>
                {isPerex && <Link className="link-internal" to={`/news/${newsId}`}>{this.props.translate("News.ReadMore")}</Link>}
            </div>
        )
    }
}

export default withLocalize(NewsContent);
